<kiwi-select-team *ngIf="isAnimator"></kiwi-select-team>
